<template>
    <Breadcrumbs main="Animation" title="Animate" />
    <div class="container-fluid">
        <div class="row">
            <animateBox />
            <animateOption />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const animateBox = defineAsyncComponent(() => import("@/components/theme/animation/animate/animateBox.vue"))
const animateOption = defineAsyncComponent(() => import("@/components/theme/animation/animate/animateOption.vue"))
</script>